var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 41.985,
    viewBox: "0 0 37 41.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "adress-books",
    d: "M35.651,41.985H4.5a1.35,1.35,0,0,1-1.348-1.348V36.188H2.2A2.2,2.2,0,0,1,0,33.993V32.068a2.2,2.2,0,0,1,2.2-2.195h.954V23.625H2.2a2.428,2.428,0,0,1-1.48-.485A1.768,1.768,0,0,1,0,21.748V20.256a1.768,1.768,0,0,1,.721-1.392,2.428,2.428,0,0,1,1.48-.485h.954V12.112H2.2A2.2,2.2,0,0,1,0,9.917V7.992A2.2,2.2,0,0,1,2.2,5.8h.954V1.348A1.35,1.35,0,0,1,4.5,0H35.651A1.35,1.35,0,0,1,37,1.348V40.637A1.35,1.35,0,0,1,35.651,41.985ZM2.2,31.434a.639.639,0,0,0-.641.635v1.925a.639.639,0,0,0,.641.635H4.715V31.434Zm16.255-9c-3.407,0-6.179,2.332-6.179,5.2a1.557,1.557,0,0,0,.75,1.274,4.792,4.792,0,0,0,1.387.638,14.37,14.37,0,0,0,4.041.519h3.455a14.37,14.37,0,0,0,4.041-.519,4.8,4.8,0,0,0,1.387-.638,1.557,1.557,0,0,0,.75-1.274c0-2.866-2.772-5.2-6.179-5.2ZM2.2,19.939c-.4,0-.641.22-.641.317v1.492c0,.1.242.317.641.317H4.715V19.939Zm17.982-8.017a4.966,4.966,0,1,0,4.966,4.967A4.972,4.972,0,0,0,20.183,11.922ZM2.2,7.358a.639.639,0,0,0-.641.635V9.917a.639.639,0,0,0,.641.635H4.715V7.358Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBooks);
export default __webpack_public_path__ + "static/media/address-books.f273b361436d64e7bd0ca68b12412e35.svg";
export { ForwardRef as ReactComponent };